<template>
  <ul class="">
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in props.items"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script setup>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@layouts/utils'

// Define las propiedades del componente
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
})

// Proporciona 'openGroups' a los componentes hijos
provide('openGroups', ref([]))

</script>
